import { exportPdf } from 'services'
import { useEvent, useState } from 'hooks'
import { getPdfExportSelector } from './selector'

type State = {
	pdfExports?: NodeListOf<HTMLElement>
}

export const PdfExport = (() => {
	const { state, setState } = useState<State>()

	const init = () => {
		setState({
			pdfExports: getPdfExportSelector(),
		})

		const { pdfExports } = state
		if (!pdfExports) return

		for (let i = 0; i < pdfExports.length; i++) {
			const exportButton = pdfExports[i]

			if (!exportButton) continue

			const click = useEvent(exportButton, 'click')
			click.register(() => {
				exportPdf(exportButton)
			})
		}
	}

	return {
		init,
	}
})()
